module.exports = __webpack_public_path__ + "static/media/Suspension-white.c5e59b5c.svg";